export default __webpack_public_path__ + "media/brand/logo-color-896cb564.png";